import * as yup from "yup";

export const AddCategoryValidationSchema = yup.object().shape({
    name: yup.string().required("Zorunlu alan!"),
    description: yup.string(),
});

export const loginValidationSchema = yup.object().shape({
    userName: yup.string().required("Zorunlu alan!"),
    password: yup.string().required("Zorunlu alan!"),
});

export const AddSubcategoryValidationSchema = yup.object().shape({
    name: yup.string().required("Zorunlu alan!"),
    description: yup.string(),
    thumbnailPhoto: yup.string(),
    categoryId: yup.string().required("Zorunlu alan!"),
});

export const AddProductValidationSchema = yup.object().shape({
    name: yup.string().required("Zorunlu alan!"),
    description: yup.string(),
    thumbnailPhoto: yup.string(),
    categoryId: yup.string().required("Zorunlu alan!"),
    subcategoryId: yup.string().nullable()
});